import BackgroundImg from '../../media/import-background.png';

export const getCampaignCreationMethodSectionStyles = () => ({
  creationMethodSelectionContainer: {
    width: '100%',
    padding: '36px 36px 34px 36px',
    border: '2px solid',
    borderImage: 'linear-gradient(90deg, #464FEB 35%, #47CFFA 70%, #B47CF8 92%) 1',
    background: `url("${BackgroundImg}")`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '24px',
    '& .header-title': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '& .campaign-creation-method-selection': {
      margin: '24px 0px',
    },
    '& .website-prompt-container': {
      border: 'none',
      background: 'transparent',
      padding: '0px 50px',
    },
  },
  'creationMethodSelectionContainer-l': {
    width: '640px',
  },
  'creationMethodSelectionContainer-m': {
    '& .campaign-creation-method-selection-item': {
      height: '150px',
    },
  },
  'creationMethodSelectionContainer-s': {
    padding: '36px 0 34px 0',
    '& .campaign-creation-method-selection-item': {
      height: '150px',
    },
  },
  importTextContainer: {
    padding: '0px 50px',
    '& .import-text': {
      textAlign: 'center',
    },
    '& .import-help-link': {
      textDecoration: 'underline',
    },
  },
});
